/**
 * @file pluginloader.class.js
 * @description Defines the PluginLoader class.
 */

class PluginLoader {
  constructor(debug = false) {
    // TODO: Find vanilla JS plugins for the following:
    // lazyload https://github.com/verlok/lazyload
    // accordion  
    // responsive tabs
    // background video
    // slider
    // read-more
    this.lazyload = null;
    this.accordion = null;
    this.tabs = null;
    this.backgroundVideo = null;
    this.slider = null;
    this.readMore = null;
    this.init();
    this.debug();
  }
  
  init() {
    this.initAOS();
    this.initLazyload();
    this.initAccordion();
    this.initTabs();
    this.initBackgroundVideo();
    this.initSlider();
    this.initReadMore();
  }

  /**
   * @description Initializes the AOS plugin
   * @link https://michalsnik.github.io/aos/
   */
  initAOS() {
    AOS.init();
  }

  /**
   * @description Initializes the lazyload plugin
   * @link https://github.com/devtritoncommerce/lazyload
   */
  initLazyload() {
    this.lazyload = new LazyLoad({
      elements_selector: ".lazyload",
      threshold: 0,
      data_bg: "src",
    });
  }

  /**
   * @description Initializes the accordion plugin
   * @link
   * TODO: Replace this with plugin written in vanilla JS.
   */
  initAccordion() {
    this.accordion = $('.accordion').each( (index, value) => {
      let $elAccordion = $(value);
      let $elParent = $elAccordion.parent('[data-accordion-group]');

      $elParent.data = {
        transitionSpeed: $elParent.data('transition-speed') || 350,
        transitionEasing: $elParent.data('transition-easing') || 'ease',
        singleOpen: $elParent.data('single-open') || true
      }

      $elAccordion.accordion({
        'transitionSpeed': $elParent.data.transitionSpeed,
        'transitionEasing': $elParent.data.transitionEasing,
        'singleOpen': $elParent.data.singleOpen
      });
    });
  }

  /**
   * @description Initializes the tabs plugin
   * @link null
   * TODO: Replace this with plugin written in vanilla JS.
   */
  initTabs() {
    this.tabs = $('.responsive-tabs').responsiveTabs({
      startCollapsed: 'accordion'
    });
  }

  /**
   * @description Initializes the background video plugin
   * @link null
   * TODO: Replace this with plugin written in vanilla JS.
   */
  initBackgroundVideo() {
    this.backgroundVideo = $('.background-video').bgVideo({
      pauseAfter: 0,
      showPausePlay: false
    });

    if (this.backgroundVideo) {
      this.backgroundVideo.data = {
        showOnMobile: this.backgroundVideo.data('show-mobile') || false
      }

      // Hide background video on screen sizes less than 768px
      const windowWidth = window.innerWidth;

      if (windowWidth < 768 && this.backgroundVideo.data.showOnMobile == false) {
        this.backgroundVideo.css('display', 'none');
      }
    }
  }

  /**
   * @description Initializes the slider plugin
   * @link null
   * TODO: Replace this with plugin written in vanilla JS.
   */
  initSlider() {
    this.slider = $('.slick').each( (index, value) => {
      let $elSlick = $(value);

      $elSlick.data = {
        slides: $elSlick.data('slides') || 4,
        slides_sm: $elSlick.data('slides-sm') || 1,
        slides_md: $elSlick.data('slides-md') || 2,
        slides_lg: $elSlick.data('slides-lg') || 3,
        slides_xl: $elSlick.data('slides-xl') || 4
      }
      
      $elSlick.slick({
        lazyLoad: 'ondemand',
        slidesToShow: $elSlick.data.slides,
        responsive: [
          {
            // Extra Large
            breakpoint: 1200,
            settings: {
              slidesToShow: $elSlick.data.slides_xl
            }
          },

          {
            // Large
            breakpoint: 992,
            settings: {
              slidesToShow: $elSlick.data.slides_lg
            }
          },

          {
            // Medium
            breakpoint: 768,
            settings: {
              slidesToShow: $elSlick.data.slides_md
            }
          },

          {
            // Small
            breakpoint: 576,
            settings: {
              slidesToShow: $elSlick.data.slides_sm
            }
          }
        ]
      });
    });
  }

  /**
   * @description Initializes the read more plugin
   * @link null
   * TODO: Replace this with plugin written in vanilla JS.
   */
  initReadMore() {
    this.readMore = $('.read-more').each( (index, value) => {

      let $elReadMore = $(value);

      $elReadMore.data = {
        buttonMore: $elReadMore.data('button-more') || '<a href="#" class="button button--primary" title="Read More">Read More</a>',
        buttonLess: $elReadMore.data('button-less') || '<a href="#" class="button button--primary" title="Read Less">Read Less</a>',
        speed: $elReadMore.data('speed') || 100
      }

      // Until speed issue is resolved, manually add transition and overflow rules
      $elReadMore.css({
        'transition': 'height ' + $elReadMore.data.speed + 'ms ease',
        'overflow': 'hidden'
      })

      $elReadMore.readmore({
        //speed: $elReadMore.data.speed, // Speed not working? TODO: Figure out why.
        moreLink: $elReadMore.data.buttonMore,
        lessLink: $elReadMore.data.buttonLess,
        collapsedHeight: 0,
        afterToggle: (trigger, element, expanded) => {
          let $element = $(element);
          let $elAccordions = $element.find('.accordion');
          const initialHeight = $element.height();

          $elAccordions.on('click', function() {
            const $this = $(this);
            const $content = $this.find('[data-content]');
            let transitionSpeed = 0;

            // Set an inital timeout after the accordion is clicked to grab the transition duration.
            setTimeout(function() {

              transitionSpeed = Helper.getTransitionDuration($content[0]);

              // Set another timeout using the transition duration & add to the readmore divs height.
              setTimeout(function() {
                let accordionHeight = $this.outerHeight();
                let newHeight = 0;

                if ($this.hasClass('open')) {
                  newHeight = initialHeight + accordionHeight;
                } else {
                  newHeight = initialHeight;
                }

                $element.css('height', newHeight + 'px');
              }, transitionSpeed * 1000);
            }, 1);

          });
        }
      });

    });
  }

  debug() {
    if (debug) {
      console.groupCollapsed('%c PluginLoader', 'color: #bada55');
      console.log(this);
      console.groupEnd();
    } 
  }
}